module.exports = __webpack_public_path__ + "static/img/logo-light.cbb35f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-light.png
// module id = 1224
// module chunks = 35